import { memo, useCallback, useState } from "react";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { FormattedMessage } from "react-intl";
import IconArrowDown from "app/pages/.shared/static/icons/IconArrowDown";
import Modal from "react-modal";
import IconCircleClose from "app/pages/.shared/IconCircleClose";
import HolidaySummaryContainer from "app/pages/Booking/HolidaySummary/HolidaySummary/HolidaySummaryContainer";
import "./CollapsableHolidaySummary.scss";
import Collapse from "rc-collapse";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer";
import useBlockScroll from "app/utils/hooks/useBlockScroll";

const style = {
	overlay: {
		backgroundColor: "rgba(43, 56, 63, .7)",
		zIndex: 5,
	},
};

const CollapsableHolidaySummary = ({ totalPrice }) => {
	const [isOpen, toggle] = useState(false);

	const handleClick = useCallback(() => {
		toggle(!isOpen);
	}, [isOpen]);

	useBlockScroll({ isModalOpen: isOpen });

	return (
		<>
			<div className="collapsable-holiday-summary" onClick={handleClick}>
				<div className="collapsable-holiday-summary__title">
					{isOpen ? (
						<>
							<IconCircleClose
								height={25}
								width={25}
								style={{ marginRight: "10px" }}
							/>
							<FormattedMessage id="booking.holiday.summary.collapsable.close.label" />
						</>
					) : (
						<>
							<IconArrowDown height={20} width={15} style={{ marginRight: "10px" }} />
							<FormattedMessage id="booking.holiday.summary.collapsable.title" />
						</>
					)}
				</div>
				{totalPrice > 0 && (
					<div className="collapsable-holiday-summary__total">
						<div>
							<FormattedMessage id="price.detail.total.label" />
						</div>
						<AmountContainer amount={totalPrice} />
					</div>
				)}
			</div>
			<Modal
				style={style}
				isOpen={isOpen}
				parentSelector={() => document.querySelector(".booking")}
				onRequestClose={handleClick}
				className="collapsable-holiday-summary__modal"
				overlayClassName="collapsable-holiday-summary__overlay"
			>
				<div className="collapsable-holiday-summary__content">
					<HolidaySummaryContainer showBookingBanner />

					<Collapse
						className="collapsable-holiday-summary__collapse"
						expandIcon={({ isActive }) => {
							return (
								<IconArrowDown
									style={{
										transform: `rotate(${isActive ? 180 : 0}deg)`,
									}}
								/>
							);
						}}
					>
						<Collapse.Panel
							headerClass="collapsable-holiday-summary__collapse-header"
							header={
								<div className="collapsable-holiday-summary__collapse-title">
									<FormattedMessage id="booking.holiday.summary.collapsable.price.breakdown" />
								</div>
							}
						>
							<QuotationPriceDetailContainer />
						</Collapse.Panel>
					</Collapse>
				</div>
			</Modal>
		</>
	);
};

CollapsableHolidaySummary.propTypes = {
	totalPrice: PropTypes.number,
};

export default memo(CollapsableHolidaySummary);
